type AppConfig = {
    ENV: string;
    VERSION: string;
    DEBUG: boolean;
    MOCK: boolean;
    BACKEND: 'yii' | 'laravel';
    APP_NAME: string;
    APP_URL: string;
    API_URL: string;
    SENTRY_DSN: string;
    GOOGLE_MAPS_KEY: string;
    AUTH_KEY: string;
    LOCALSTORAGE_EXPIRES_KEY: string;
    LOCALSTORAGE_EXPIRES_TIME: number;
};

export enum Roles {
    ADMIN = 'admin',
    ZONE_ADMIN = 'zone_admin',
    ZONE_MANAGER = 'zone_manager',
    STAFF = 'staff',
}

// .env constants
const {
    REACT_APP_ENV,
    REACT_APP_VERSION,

    REACT_APP_APP_NAME,
    REACT_APP_URL,
    REACT_APP_API_URL,

    REACT_APP_SENTRY_DSN,
    REACT_APP_GOOGLE_MAPS_KEY,
} = process.env;

// APP CONSTANTS
const app:AppConfig = {
    ENV: REACT_APP_ENV || 'local',
    VERSION: REACT_APP_VERSION || '0.0.0',
    DEBUG: REACT_APP_ENV === 'local',
    MOCK: false,
    BACKEND: 'yii', // or 'laravel'

    APP_NAME: REACT_APP_APP_NAME || 'Scorchsoft React Boilerplate',

    APP_URL: REACT_APP_URL || 'http://localhost:3000',
    API_URL: REACT_APP_API_URL || '',

    SENTRY_DSN: REACT_APP_SENTRY_DSN || '',
    GOOGLE_MAPS_KEY: REACT_APP_GOOGLE_MAPS_KEY || '',

    AUTH_KEY: 'auth-key',
    LOCALSTORAGE_EXPIRES_KEY: 'session-token-expiry',
    LOCALSTORAGE_EXPIRES_TIME: 30, // minutes
};

export default app;
